var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-contact-search", {
    attrs: {
      value: _vm.contact,
      "group-id": _vm.groupId,
      label: _vm.label,
      fancy: _vm.fancy,
      "disable-create": _vm.disableCreate,
      disabled: _vm.disabled,
      "icon-left": _vm.iconLeft,
      "icon-left-tooltip": _vm.iconLeftTooltip,
    },
    on: {
      input: function ($event) {
        return _vm.onNewContact($event)
      },
      blur: function ($event) {
        return _vm.$emit("blur")
      },
      focus: function ($event) {
        return _vm.$emit("focus")
      },
      "icon-left-click": function ($event) {
        return _vm.$emit("icon-left-click")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }